import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Error } from '../models';
import { IssueReportingService } from '../issue-reporting.service';

@Component({
  selector: 'app-error-item',
  templateUrl: './error-item.component.html',
  styleUrls: ['./error-item.component.scss']
})
export class ErrorItemComponent implements OnInit {
  @Input() error: Error;
  @Output() onDismiss = new EventEmitter<Error>();

  errorLink = '';

  constructor(private issueReporting: IssueReportingService) {}

  ngOnInit() {
    this.errorLink = this.issueReporting.getReportIssueWithErrorMailLink(this.error);
  }
}
